var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "table-responsive" }, [
      _c("table", [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _c(
              "tr",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.logs.length === 0,
                    expression: "logs.length === 0"
                  }
                ]
              },
              [_vm._m(2)]
            ),
            _vm._v(" "),
            _vm._l(_vm.logs, function(log, index) {
              return _c("tr", { key: index }, [
                _c("td", [_vm._v(_vm._s(log.descripcion_estado))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(log.tipo))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(log.motivo))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(log.usuario.nombre))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(log.created_at))])
              ])
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cerrar")
            }
          }
        },
        [_c("i", { staticClass: "fa fa-ban" }), _c("span", [_vm._v("Cerrar")])]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("h3", [_vm._v("Logs")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Proceso")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tipo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Motivo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Usuario")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "5" } }, [
      _c("strong", [_vm._v("No hay logs.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56a6f96d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a6f96d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inspeccion/ReporteLogs.vue
// module id = 379
// module chunks = 0